import React from 'react'
import {
  Typography,
  Tooltip,
  Badge,
  Divider
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { dateToAgo, pythonDateTimeToJsObj } from 'helpers/dataHelpers'
import { ReactComponent as DomainIcon } from 'static/icons/domain.svg'
import { ReactComponent as AdviceIcon } from 'static/icons/advice-not.svg'
import { ReactComponent as UserIcon } from 'static/icons/user-not.svg'
import { ReactComponent as RequestIcon } from 'static/icons/request-not.svg'
import { setReadCommonNotification } from 'utils/notifications/actions'
import history from 'browserHistory'
import useStyles from './styles'


const CommonNotificationListItem = (props) => {
  const {
    id,
    name,
    text,
    notification_type,
    related_object,
    created,
    read,
    additional_data,
    setShowNotifications
  } = props
  const dispatch = useDispatch()
  const localClasses = useStyles()

  const closeDrawer = (event) => {
    if (setShowNotifications) {
      setShowNotifications(false)
    }
  }

  const handleRead = (event) => {
    if (read) {
      return
    }
    dispatch(setReadCommonNotification(id))
  }

  const renderIcon = () => {
    switch (notification_type) {
      case 'DOMAIN':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Domain'>
                    <DomainIcon />
                  </Tooltip>
                </Badge>)
      case 'ROOM':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Room'>
                    <DomainIcon />
                  </Tooltip>
                </Badge>)
      case 'ASSIGN':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Assign'>
                    {
                      additional_data['targetType'] === 'ADVICE' ?
                        <AdviceIcon/> :  <RequestIcon />
                    }
                  </Tooltip>
                </Badge>)
      case 'ADVICE':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Advice'>
                    <AdviceIcon />
                  </Tooltip>
                </Badge>)
      case 'USER':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='User'>
                    <UserIcon />
                  </Tooltip>
                </Badge>)
      case 'GROUP':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Group'>
                    <UserIcon />
                  </Tooltip>
                </Badge>)
      case 'ROLE':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Role'>
                    <UserIcon />
                  </Tooltip>
                </Badge>)
      case 'COMMENT':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Comment'>
                    <RequestIcon />
                  </Tooltip>
                </Badge>)
      case 'MENTION':
        return (<Badge
                  invisible={read}
                  color='error'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant='dot'
                  className={localClasses.typeIcon}
                >
                  <Tooltip title='Mention'>
                    <UserIcon />
                  </Tooltip>
                </Badge>)
      default:
        return <DomainIcon />
    }
  }

  const handleClick = (event) => {
    event.stopPropagation()
    const target_type = additional_data['targetType']
    switch (notification_type) {
      case 'DOMAIN':
        if (target_type === 'CREATE_DOMAIN') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/advices?activeDomain=${related_object}`)
        } else {
          handleRead(event)
        }
        break
      case 'ROOM':
      if (target_type === 'CREATE_ROOM') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/advices?activeRoom=${related_object}&activeDomain=${additional_data['domainId']}`)
        } else {
          handleRead(event)
        }
        break
      case 'ASSIGN':
        if (target_type === 'ADVICE') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/advices/${related_object}`)
        } else if (target_type === 'REQUEST') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/requests/${related_object}`)
        }
        break
      case 'ADVICE':
        if (target_type === 'COMPLETE_ADVICE') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/advices/${related_object}`)
        } else {
          handleRead(event)
        }
        break
      case 'USER':
        handleRead(event)
        break
      case 'GROUP':
        if (target_type === 'CREATE_GROUP') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/groups/${related_object}`)
        } else {
          handleRead(event)
        }
        break
      case 'ROLE':
        if (target_type === 'CHANGE_ROLE') {
          handleRead(event)
        }
        break
      case 'COMMENT':
        if (target_type === 'ADVICE') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/advices/${related_object}`)
        } else {
          handleRead(event)
          closeDrawer(event)
          history.push(`/requests/${related_object}`)
        }
        break
      case 'MENTION':
        if (target_type === 'ADVICE') {
          handleRead(event)
          closeDrawer(event)
          history.push(`/advices/${related_object}`)
        } else {
          handleRead(event)
          closeDrawer(event)
          history.push(`/requests/${related_object}`)
        }
        break
      default:
        return handleRead
    }
  }

  return (
    <>
      <div
        id={id}
        className={`${localClasses.notification} ${read ? localClasses.isRead : ''}`}
        onClick={handleClick}
      >
        <div className={localClasses.name}>
          <div className={localClasses.headers}>
            {renderIcon()}
            <div className={localClasses.fullWidth}>
              <Tooltip
                title={
                  <React.Fragment>
                    {name}
                  </React.Fragment>
                }
                placement='bottom'
                classes={{
                  popper: localClasses.tooltip
                }}
              >
                <Typography variant='body2' noWrap className={`${localClasses.title} ${!read && 'unread'}`}>
                  {name}
                </Typography>
              </Tooltip>
              <Typography variant='caption' color='textSecondary'>
                {text}
              </Typography>
            </div>
          </div>
        </div>
        <div className={localClasses.created}>
          <Typography variant='body2' color='textSecondary'>
            {dateToAgo(pythonDateTimeToJsObj(created))}
          </Typography>
        </div>
      </div>
      <Divider />
    </>
  )
}

export default CommonNotificationListItem
